import { Component, input } from "@angular/core";
import { ExpandableListModel } from "./model/expandable-list-model";
import { ExpandableListStyleModel } from "./model/expandable-list-style-model";
import { TranslatePipe } from "@ngx-translate/core";
import { ListElementComponent } from "./list-element/list-element.component";

@Component({
  selector: "portal-expandable-list",
  templateUrl: "./expandable-list.component.html",
  styleUrls: ["./expandable-list.component.scss"],
  standalone: true,
  imports: [TranslatePipe, ListElementComponent],
})
export class ExpandableListComponent {
  readonly model = input.required<ExpandableListModel>();
  readonly style = input<ExpandableListStyleModel>();
  id: string;

  constructor() {
    this.id = "gast" + Math.random().toString(36).substring(7);
  }
}
